import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import styled from 'styled-components'

import { AutocallForm, AutocallFormItem, CertPart } from '@/shared/components/Common/form'
import TelecomSelector from '@/shared/components/Common/form/TelecomSelector'
import { useCertOTP, useModal, useSendOTP, useValidate } from '@/shared/hooks'
import { cancelerrTxtActive, isLoading } from '@/shared/recoil/common/atom'
import { otpAuthType, otpPNumber, otpTelecom } from '@/shared/recoil/otp/atom'
import { validateTypeFam } from '@/shared/recoil/validate/atom'
import { pNumAndCertNumWithValidate } from '@/shared/recoil/validate/withFormItem'
import { OtpCertFormContainer } from '@/styles/Common/form_styled'

const CancelPage = () => {
  const [pTelecom, setPTelecom] = useRecoilState(otpTelecom)
  const navigate = useNavigate()
  const send = useSendOTP()
  const { join } = useValidate()
  const { certNumber } = join
  const cert = useCertOTP()
  const setAuthType = useSetRecoilState(otpAuthType)
  const modal = useModal()
  const pNumber = useRecoilValue(otpPNumber)
  const pNumAndCertNumValid = useRecoilValue(pNumAndCertNumWithValidate)
  const certNumValidState = useRecoilState(validateTypeFam('certNumber'))
  const pNumberValidState = useRecoilState(validateTypeFam('phoneNumber'))
  const setErrtxt = useSetRecoilState(cancelerrTxtActive)
  const cancelButtonRef = useRef<HTMLButtonElement>(null)
  const certRef = useRef<HTMLInputElement>(null)
  const visible = useRecoilValue(isLoading)

  const CancelSumbit = async () => {
    const buttonEle = cancelButtonRef.current
    const inputEle = certRef.current
    if (buttonEle) buttonEle.blur()
    if (inputEle) inputEle.blur()

    setErrtxt(true)
    certNumber.recoilState[1]({ valid: true, msg: '030009' })
    if (pNumber.length < 11) {
      certNumber.recoilState[1]({ valid: true, msg: '200' })
    } else {
      if (await cert.cancel()) {
        await modal.alert({
          title: '정상적으로 해지 되었습니다.',
          contents:
            '가입 당일 해지하신 고객님은 요금이 청구되지 않습니다. 서비스 이용요금은 매월 사용일 수 만큼 계산되어 청구됩니다.',
          onCancel: () => {
            navigate('/')
            window.location.reload()
          },
          onConfirm: () => {
            navigate('/')
            window.location.reload()
          },
        })
      }
    }
  }

  useEffect(() => {
    setErrtxt(false)
    setAuthType('delete')
    pNumberValidState[1]({ valid: false, msg: '' })
    certNumValidState[1]({ valid: false, msg: '' })
  }, [setErrtxt, setAuthType])

  /*20231024 lgu+ 가입/해지 불가 모달*/
  /*useServiceModal(dayjs(SERVICE_DATE.CANCEL_START_DT), dayjs(SERVICE_DATE.END_DT))*/
  return (
    <AutocallForm>
      <OtpCertFormContainer>
        <h1>
          서비스 해지를 위해 <br /> 본인인증을 진행해주세요.
        </h1>
        <section>
          <TelecomSelector telecom={pTelecom} setTelecom={setPTelecom} />
        </section>
        <AutocallFormItem title="" validate={pNumAndCertNumValid} essential>
          <CertPart
            certRef={certRef}
            onSendOTP={async () => await send.request()}
            onCertOTP={CancelSumbit}
          />
        </AutocallFormItem>
        <button
          disabled={visible}
          ref={cancelButtonRef}
          className="cancel_submit"
          onClick={CancelSumbit}
        >
          서비스 이용해지
        </button>
        <p className="cancel_notice-text">
          가입 당일 해지하신 고객님은 요금이 청구되지 않습니다.
          <br />
          서비스 이용요금은 매월 사용일 수 만큼 계산되어 청구됩니다.
        </p>
      </OtpCertFormContainer>
    </AutocallForm>
  )
}

export default CancelPage
